import { useMutation } from '@tanstack/react-query';
import { userService } from '../../services/userService';

export const useVerifyRecoveryToken = () => {
  return useMutation({
    mutationFn: payload =>
      userService.verifyRecoveryToken(payload).then(response => {
        const { data } = response;
        return data?.token ?? null;
      }),
  });
};
